import React from 'react';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import LoadingSpinner from 'components/lib/ui/LoadingSpinner';
import TextButton from 'components/lib/ui/TextButton';
import type { TextButtonProps } from 'components/lib/ui/TextButton';

interface Props extends TextButtonProps {
  className?: string;
  children: ReactNode;
  isLoading?: boolean;
}

const StyledLoadingSpinner = styled(LoadingSpinner)`
  width: 21px;
  height: 21px;
  display: flex;
  align-items: center;
`;

const StyledTextButton = styled(TextButton)`
  padding: 0;
`;

export const AsyncTextButton = ({ className, children, isLoading = false, ...props }: Props) => (
  <div className={className}>
    {isLoading ? (
      <StyledLoadingSpinner />
    ) : (
      <StyledTextButton {...props}>{children}</StyledTextButton>
    )}
  </div>
);
